<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-5">
    <!--Card 1-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Clientes</div>
        <h3 class="text-gray-700 text-base">
         {{clientes}}
        </h3>
        
      </div>
    </div>
     <!--Card 2-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Empresas</div>
        <p class="text-gray-700 text-base">
            {{kilos}}
        </p>
      </div>
    </div>
   

    <!--Card 3-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Articulos</div>
        <p class="text-gray-700 text-base">
            {{cajas}}
        </p>
      </div>
    </div>
    <!--Card 4-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Proyetos</div>
        <h4 class="text-gray-700 text-base">
         {{envios}}
        </h4>
      </div>
    </div>
    
  </div>
  <!--ini-->
  <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5">
  <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
  <div class="small">
     <div class="font-bold text-xl mb-2"></div>
    <line-chart :chart-data="datacollection"></line-chart>
    
  </div>
      </div>
  </div>

 <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
  <div class="small">
    <div class="font-bold text-xl mb-2"></div>
    <bar-chart :chart-data="datacollection2"></bar-chart>
   
  </div>
      </div>
  </div>
  </div>
</div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LineChart from '@/Shared/LineChart'
import BarChart from '@/Shared/Bar'



export default {
  metaInfo: { title: 'Dashboard' },
  components: {
    LineChart,
    BarChart
  },
  layout: Layout,
  props: {
    clientes: Number,
    envios: Number,
    cajas: Number,
    kilos: Number,
    meses: Array,
    fp: Array,
    rp: Array,
    e: Array,
    f: Array,
    m: Array,
    a: Array,
    ma: Array,
    j: Array,
    ju: Array,
    ag: Array,
    s: Array,
    o: Array,
    n: Array,
    d: Array,


  },
data () {
      return {
        datacollection: null,
        datacollection2: null,
      }
    },
    mounted () {
      this.fillData(),
      this.fillData2()
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: this.meses,
          datasets: [
            {
              label: 'Pedidos',
              backgroundColor: '#ffd911',
              data: this.fp
            }, {
              label: 'Solicitados',
              backgroundColor: '#8fce00',
              data: this.rp
            }
          ]
        }
      },
      fillData2 () {
        this.datacollection2 = {
          labels: ['Enero','Febrero',,'Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
          datasets: [
            {
              label: 'Inicio',
              backgroundColor: '#ffd911',
              data: this.e
            }, {
              label: 'Fin',
              backgroundColor: '#8fce00',
              data:this.f
            }
          ]
        }
      },
      getRandomInt () {
        return Math.floor(Math.random() * (150 - 5 + 1)) + 5
      }
    }
  }
</script>
<style>
  .small {
    max-width: 300px;
    margin:  10px auto;
  }
</style>